/**
 * i18n keys of the studio / permission catalog texts (CT-5828). The API sends English labels and
 * descriptions; a translation under `catalog.*` wins and the API text stays as the fallback, so a
 * permission added later still renders. Dots of an id become underscores (dots nest in i18next).
 */
const idKey = (id) => String(id).replace(/\./g, '_');

/** Key of a studio's description. */
export const studioDescriptionKey = (studioId) => `catalog.studios.${idKey(studioId)}.description`;

/** Key of a permission's `label` or `description`. */
export const permissionTextKey = (permissionId, field) => `catalog.permissions.${idKey(permissionId)}.${field}`;
